import { useClickOutside } from '@btime/react-hooks'
import React from 'react'

import { generateOnPickerChange } from '../../components/form/picker/_helpers'

export const useControlledDropdown = ({ wrapperRef, value, onChange, onClose, multiple, idField, options }) => {
  const [open, setOpen] = React.useState(false)
  const [current, setCurrent] = React.useState(0)
  const handleClose = () => {
    setOpen(false)
    if (onClose) onClose()
  }

  // TODO: Move to inside kiti package
  useClickOutside(wrapperRef, { action: handleClose })

  const directOnChange = generateOnPickerChange(value, onChange, { multiple, idField })
  const handleChange = v => {
    onChange(v)
    if (!multiple) handleClose()
  }

  const onKeyDown = e => {
    if (e.code === 'ArrowDown') {
      setOpen(true)

      if (options.length - 1 > current) {
        setCurrent(current + 1)
      }
    } else if (e.code === 'ArrowUp') {
      if (current > 0) {
        setCurrent(current - 1)
      }
    } else if (e.code === 'Tab') {
      handleClose()
    } else if (e.code === 'Enter') {
      directOnChange(options[current])
      if (!multiple) handleClose()
    } else if (e.code === 'Escape') {
      setOpen(false)
    }
  }

  return {
    onKeyDown,
    handleChange,
    open,
    setOpen,
    handleClose,
    current,
    setCurrent
  }
}
